window.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {

        $('.landing-page__see-more').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('hidden');
            $('.landing-page__show-items').text($('.landing-page__show-total').text());
        
            $('a.camp-card__hitpoint').each(function (el) {
              $(this).removeClass('hidden');
            });
    
          });
     
        $('.open-camp-types-modal').on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
        
            $('.camp-types-modal__viewport').toggleClass('active', true);
        });
        
        $('.close-camp-types-modal').on('click', function (e) {
            e.preventDefault();
        
            $('.camp-types-modal__viewport').toggleClass('active', false);
        });

    });
  });
  